// extracted by mini-css-extract-plugin
export default {"image":"ImageCell_image__QV4d+"};